<div class="public-wrap blog-details-wrap">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="back-link-outer">
          <div class="back-link-outer mb-3 pb-1 d-flex">
            <a class="back-link cursor-pointer" routerLink="../">
              <img alt="back" src="../assets/images/back.svg" /> back
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="public-wrap-inner" *ngIf="blog !== undefined">
      <div class="row">
        <div class="col-12">
          <p class="blog-by mb-3">
            By <span class="author-name">{{ blog.author }}</span> on
            {{ blog.createdOn | date }}
          </p>
        </div>

        <div class="col-12">
          <h2 class="wrap-hdg">{{ blog.title }}</h2>
        </div>

        <div class="col-12">
          <img
            alt="blog-image"
            [src]="blog.coverImagePath"
            class="blog-image img-fluid"
          />
        </div>

        <div class="col-12 blog-details-des" [innerHtml]="blog.content"></div>
        <div class="col-12 pb-5">
          <div class="shareTheBlog">
            <div class="row">
              <div class="col-12 col-md-4 mt-4">
                <p class="mb-0">Share Article To:</p>
                <a
                  class="mr-2"
                  href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fthebranfordgroup.com%2Fnews%2F{{blog.id}}"
                  target="_blank"
                >
                  <img src="../assets/images/facebook.svg" />
                </a>
                <a
                  class="mr-2"
                  href="https://twitter.com/intent/tweet?url=https%3A%2F%2Fthebranfordgroup.com%2Fnews%2F{{blog.id}}"
                  target="_blank"
                >
                  <img src="../assets/images/twitter.svg" />
                </a>
                <a
                  class="mr-2"
                  href="https://www.instagram.com/thebranfordgroup/?hl=en"
                  target="_blank"
                >
                  <img src="../assets/images/instagram.svg" />
                </a>
                <a
                  href="https://www.linkedin.com/sharing/share-offsite/?url=https%3A%2F%2Fthebranfordgroup.com%2Fnews%2F{{blog.id}}"
                  target="_blank"
                >
                  <img src="../assets/images/linkedin.svg" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row recent-blog-wrapper">
        <div class="col-12">
          <h2 class="recent-blog-hdg">Recent News</h2>
        </div>

        <div class="col-12">
          <div class="row">
            <div
              class="col-md-6 col-lg-4 recent-blogs-wrap"
              *ngFor="let blogList of blogData"
            >
              <div class="wrap-inner">
                <div class="image-wrap">
                  <img
                    alt="recent-blog-image"
                    [src]="blogList.coverImagePath"
                    class="recent-blog-image img-fluid"
                  />
                </div>
                <div class="des-wrap">
                  <h1 class="blog-name">
                    <a routerLink="../{{ blogList.id }}">{{
                      blogList.title
                    }}</a>
                  </h1>
                  <p class="blog-by m-0">
                    By
                    <span class="author-name">{{ blogList.author }}</span>
                    <br />
                    {{ blogList.createdOn | date }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
